<template>
    
</template>

<script>
    import store from './../store'
    export default {
        name: "Logout",

        mounted() {
            store.commit('LOGOUT_USER');
            localStorage.removeItem('token');
            this.$router.go(-1);
        }
    }
</script>

<style scoped>

</style>